import React from 'react';

import cx from 'classnames';

import { getItineraryNavLinks } from 'components/Pages/Admin/Page/Landing/utils';
import LandingPagesContainer from 'components/shared/LandingPage/components/Grid';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useCustomStyles, useCustomFonts } from 'hooks/useCustomFront';
import { useScrollLandingToTop } from 'hooks/useScrollLandingToTop';
import { isCurrentProposal } from 'utils/proposals';

import s from './index.module.css';
import ItineraryLandingPage from './ItineraryLandingPage';
import { useWebViewScroll } from './useWebViewScroll';

function ItineraryLandingPages(props) {
  useScrollLandingToTop();
  const {
    pages: rawPages,
    itineraryItem,
    withNavHeader,
    extraHeaderOptionsLandingPageContext,
    isPrivate,
    manageHideCostsPermission,
    landingTheme,
    className,
    itinerariesItemType,
  } = props;

  const customStylesTargetItem =
    itinerariesItemType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL ? itineraryItem.itinerary : itineraryItem;
  useCustomStyles({ css: customStylesTargetItem?.customStyles, customId: customStylesTargetItem.id });
  useCustomFonts({ landingItem: customStylesTargetItem, customId: customStylesTargetItem.id });
  const pages = rawPages
    .map((page) => {
      if (!page.title) {
        return { ...page, title: page.headline };
      }

      return page;
    })
    .filter((page) => !page.hidden && !page.empty);
  const navLinks = getItineraryNavLinks(pages);

  const isCurrentTrip = React.useMemo(() => isCurrentProposal(itineraryItem), [itineraryItem]);
  useWebViewScroll({ pages, landingTheme, isCurrentTrip });

  return (
    <LandingPagesContainer
      className={cx(
        s.landingPagesContext,
        withNavHeader && s.landingPagesContextWithNavHeader,
        `custom-main-${landingTheme}`,
        className,
      )}
    >
      {/*{!isTabletOrMobile && (*/}
      {/*  <NavNotch*/}
      {/*    landingTheme={landingTheme}*/}
      {/*    links={navLinks}*/}
      {/*    isPortalItinerary*/}
      {/*    className={cx(withNavHeader && s.notchWithNavHeader)}*/}
      {/*  />*/}
      {/*)}*/}
      {pages.map((page, i) => (
        <ItineraryLandingPage
          key={i}
          landingData={page}
          anchor={navLinks[i]}
          screens={navLinks}
          pageIndex={i}
          page={itineraryItem}
          isLastPage={i === pages.length - 1}
          isPrivate={isPrivate}
          manageHideCostsPermission={manageHideCostsPermission}
          extraHeaderOptionsLandingPageContext={extraHeaderOptionsLandingPageContext}
          landingTheme={landingTheme}
        />
      ))}
    </LandingPagesContainer>
  );
}

export default ItineraryLandingPages;
